export default __webpack_public_path__ + "static/media/report.682f2b36.png";